import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

export const firebaseConfig = {
  apiKey: "AIzaSyCiL0449cK5JLJn-Tima8pUBVxP1Nk9eTM",
  authDomain: "angeles-del-puerto.firebaseapp.com",
  projectId: "angeles-del-puerto",
  storageBucket: "angeles-del-puerto.firebasestorage.app",
  messagingSenderId: "1004718994872",
  appId: "1:1004718994872:web:0a97eb90acc063f11d0b4d",
  measurementId: "G-639S4V79Y6"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
getAnalytics(app);

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LfvhoMsAAAAAFVtS1L-N05IYgzSs8EcYmIeSiQi'),
  isTokenAutoRefreshEnabled: true
});



